import { render } from "./workflow-review-status.vue?vue&type=template&id=64524a01"
import script from "./workflow-review-status.vue?vue&type=script&lang=js"
export * from "./workflow-review-status.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__